function Master() {
    /// <summary>
    /// This object provides common functions for the Widget.Master visuals. <br/>
    /// It allows to add/delete favorites and provides message functions.
    /// Author: ARF<br />
    /// Date: 28.9.2015<br />
    /// Copyright ©: EUDT GmbH 2015 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 1.10.2015                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
}
Master.prototype = new vcTemplate();

Master.prototype.toggleBtnFilterFav = function (obj, optgroupid) {
    /// <summary>
    /// This function show/hides all entries or favorites only. It stores the setting as user option. 
    /// </summary>
    var me = this;
    try {
       
        obj.toggleClass("button-toggle-active");
        me.filterFav = obj.hasClass("button-toggle-active");
        me.userOptions.setUserOptions({ 'optgroupid': optgroupid, 'optid': parseInt(obj.attr("data-optid"), 10), 'bval': me.filterFav }, function () { });
        me.filter();
        return true;
    } catch (ex) { me.writeError('toggleBtnFilterFav', ex); return false; }
};


Master.prototype.doEvent = function (event) {
    /// <summary>
    /// Not needed here right now ...
    /// </summary>
    //var me = this;
    try {
        switch (event.msg) {
        //    case 'MY_EVENT': alert(event.values); break;
        //    default: break;
        }
    } catch (ex) { writeError('doEvent', ex); }
};

Master.prototype.adoptListHeight = function () {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    var h, bh;
    try {
      
        if (me.mobile === false) {
            h = parseInt(me.visual.find(".list").height());
            bh = parseInt(_iBrowserHeight) -
                parseInt($("#header").height() + $("#divMasterBack").height() + me.visual.find(".filter").height());
            if (h > bh) {
                me.visual.find(".list").height(bh - 70).css("overflow-y", "auto");
            }
        } else {
           
            me.visual.find(".list").css("overflow-y", "auto");
        }
    } catch (ex) { me.writeError('adoptListHeight', ex);  }
};

Master.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find('.list').hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};

